// extracted by mini-css-extract-plugin
export var cardHeader = "_iy-0";
export var reorderHandle = "_iy-3";
export var titleArea = "_iy-1";
export var titleAreaWithHandle = "_iy-2";